module.exports = __webpack_public_path__ + "img/money.e0767eaa.png";